import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as getTime from '~/skills/getTime';
import * as getStatus from '~/skills/getStatus';
import Actions from '~/Actions';
import Actions_Wind from '~/Actions_Wind';
import PageTitle from '~/components/PageTitle';
import SearchBar from '~/components/SearchBar';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Date, EAA_Memo, EAA_Input, EAA_ErrorText, EAA_Upload, EAA_Status, EAA_UpdateTime, EAA_BottomBtn } from '~/components/EditAndAddItem';
import Tree from '~/components/Tree';

import Extend_Additional from './Extend_Additional';

// import { DndProvider } from 'react-dnd';
// import { HTML5Backend } from 'react-dnd-html5-backend';

const modeInfo = {
  add: {
    title: '股權新增',
  },
  edit: {
    title: '股權編輯',
  },
  view: {
    title: '股權檢視',
  },
};

class AddAndEdit extends Component {
  state={ data: {}, old_data: {}, mode: '', canSend: true, errorAry: [] }
  componentDidMount () {
    const { id, getAEquityIdDetail, mode = '', setPageText } = this.props;
    setPageText(modeInfo[mode].title);
    if (mode !== 'add')getAEquityIdDetail(id);
  }

  componentDidUpdate (preProps) {
    const { AEquityIdDetail: preAEquityIdDetail = {} } = preProps;
    const { AEquityIdDetail = {}, mode } = this.props;
    if (Object.keys(preAEquityIdDetail).length === 0 && Object.keys(AEquityIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ data: AEquityIdDetail, old_data: JSON.parse(JSON.stringify(AEquityIdDetail)) });
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('AEquityIdDetail');
    clearKey('PageText');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  getSendBody=() => {
    const { data } = this.state;
    const body = {
      official_doc_date: data.official_doc_date || '',
      official_doc_num: data.official_doc_num || '',
      official_doc_upload_files: data.official_doc_upload_files || [],
      contract_select_rule: data.contract_select_rule || '',
      event_note: data.event_note || '',
      equity_upload_imgs: data.equity_upload_imgs || [],
      equity_change_note: data.equity_change_note || '',
      original_equity: data.original_equity || '[]',
      change_equity: data.change_equity || '[]',
      review_results: data.review_results || '',
      review_official_doc_date: data.review_official_doc_date || '',
      review_official_doc_num: data.review_official_doc_num || '',
      review_official_doc_upload_files: data.review_official_doc_upload_files || [],
      sub1: data.sub1 || [],

      windcontract_id: Actions_Wind.wind_id(),
    };
    return body;
  }

  add=(status = {}) => {
    this.setState({ canSend: false });
    const body = { ...this.getSendBody(), ...status };
    this.props.postAddNewAEquity(body);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=(status = {}) => {
    this.setState({ canSend: false });
    const { id, putAEquityIdDetail } = this.props;
    const body = { ...this.getSendBody(), ...status };
    putAEquityIdDetail(id, body);
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.official_doc_date) === '', // 0 股權變更申請函 - 公文日期
      returnInputValue(data.official_doc_num) === '', // 1 股權變更申請函 - 公文文號
      (data.official_doc_upload_files || []).length === 0, // 2 股權變更申請函 - 上傳檔案
      returnInputValue(data.contract_select_rule) === '', // 3 申請變更依據 - 勾選
      returnInputValue(data.event_note) === '', // 4 申請變更依據 - 事項填寫
      (data.equity_upload_imgs || []).length === 0, // 5 擬變更股權架構圖 - 上傳檔案
      returnInputValue(data.equity_change_note) === '', // 6 申請變更事項說明 - 說明
      returnInputValue(data.review_official_doc_date) === '', // 7 審查結果 - 公文日期
      returnInputValue(data.review_official_doc_num) === '', // 8 審查結果 - 公文文號
      (data.review_official_doc_upload_files || []).length === 0, // 9 審查結果 - 上傳檔案
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { mode = '' } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const disabled = mode === 'view' || isCheck || (!getStatus.canEdit(data));
    // const { status = '0' } = data;
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const checkFilesChange = label => isCheck ? JSON.stringify(data[label] || []) !== JSON.stringify(old_data[label] || []) : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const allRight = errorAry.indexOf(true) === -1;
    const titleWidth = 170;
    const errorLeft = 20 + titleWidth;

    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text={modeInfo[mode].title} />
        <div style={{ height: 8 }} />

        <SearchBar text='股權變更申請函' defaultOpen forceOpen={errorAry[0] || errorAry[1] || errorAry[2]}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='公文日期' bol={true} haveChange={checkChange('official_doc_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.official_doc_date)} onChange={data => this.changeData({ label: 'official_doc_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='起選擇日期' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='公文文號' bol={true} haveChange={checkChange('official_doc_num')} />
                <EAA_Input displayBorder disabled={disabled} unit='字號' value={returnInputValue(data.official_doc_num)} onChange={data => this.changeData({ label: 'official_doc_num', data })} />
              </EAA_ItemContainer>
              {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
          </EAA_Row>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='上傳檔案' bol={true} haveChange={checkFilesChange('official_doc_upload_files')} />
                <EAA_Upload displayBorder disabled={disabled} value={data.official_doc_upload_files || []} onChange={data => this.changeData({ label: 'official_doc_upload_files', data })} />
              </EAA_ItemContainer>
              {/* {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='帳號需為 1 ~ 100 英數字。' />} */}
            </EAA_Item>
          </EAA_Row>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='申請變更依據' forceOpen={errorAry[3]}>
          <EAA_TitleText width={titleWidth} text='請勾選下列契約條文' subtitle={errorAry[3] ? '請勾選' : ''} subtitleColor='red' bol={true} haveChange={checkChange('contract_select_rule')} />
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <CircleCheckBox value={data.contract_select_rule === '1'} onClick={() => this.changeData({ label: 'contract_select_rule', data: '1' })} />
                <div style={{ textAlign: 'start', marginLeft: 8 }}>
                  <div>離岸風電規劃場址遴選契約書(中華民國 109 年完工併聯) :第 12 條第 2 項(經甲方認定屬重要事項之變更，應報請甲方同意)</div>
                </div>
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <CircleCheckBox value={data.contract_select_rule === '2'} onClick={() => this.changeData({ label: 'contract_select_rule', data: '2' })} />
                <div style={{ textAlign: 'start', marginLeft: 8 }}>
                  <div>離岸風電規劃場址遴選契約書(中華民國 110-114 年完工併聯) :第 13 條第 2 項(經甲方認定屬重要事項之變更，應報請甲方同 意。)</div>
                </div>
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <CircleCheckBox value={data.contract_select_rule === '3'} onClick={() => this.changeData({ label: 'contract_select_rule', data: '3' })} />
                <div style={{ textAlign: 'start', marginLeft: 8 }}>
                  <div>離岸風電規劃場址競價契約書:第 13 條第 3 項(乙方就本契約之權利義務關係，非經甲方書面同意，不得移轉或讓與。)</div>
                </div>
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='申請變更事項' forceOpen={errorAry[4]}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='事項填寫' bol={true} haveChange={checkChange('event_note')} />
                <EAA_Memo displayBorder disabled={disabled} hint='詳答' value={returnInputValue(data.event_note)} onChange={data => this.changeData({ label: 'event_note', data })} />
              </EAA_ItemContainer>
              {errorAry[4] && <EAA_ErrorText marginLeft={errorLeft} text='請填寫' />}
            </EAA_Item>
          </EAA_Row>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='擬變更股權架構圖' forceOpen={errorAry[5]}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='上傳檔案' bol={true} haveChange={checkFilesChange('equity_upload_imgs')} />
                <EAA_Upload displayBorder disabled={disabled} value={data.equity_upload_imgs || []} onChange={data => this.changeData({ label: 'equity_upload_imgs', data })} />
              </EAA_ItemContainer>
              {/* {errorAry[5] && <EAA_ErrorText marginLeft={errorLeft} text='帳號需為 1 ~ 100 英數字。' />} */}
            </EAA_Item>
          </EAA_Row>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='申請變更事項說明' forceOpen={errorAry[6]}>
          <div style={{ fontWeight: 700, fontSize: 20, color: '#064b6f', textAlign: 'start' }}>變更股權架構</div>
          <EAA_Row style={{ marginTop: 8 }}>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='擬變更股權架構說明' bol={true} haveChange={checkChange('equity_change_note')} />
                <EAA_Memo displayBorder disabled={disabled} hint='詳答' value={returnInputValue(data.equity_change_note)} onChange={data => this.changeData({ label: 'equity_change_note', data })} />
              </EAA_ItemContainer>
              {errorAry[6] && <EAA_ErrorText marginLeft={errorLeft} text='請說明' />}
            </EAA_Item>
          </EAA_Row>
          <div style={{ marginTop: 24, fontWeight: 700, fontSize: 20, color: '#064b6f', textAlign: 'start' }}>股權架構</div>
          {!!Object.keys(old_data).length && <div style={{ marginTop: 24, fontWeight: 500, fontSize: 18, color: '#064b6f', textAlign: 'start' }}>原股權架構</div>}
          <Tree disabled={disabled || !!Object.keys(old_data).length} data={data.original_equity || '[]'} onChange={data => this.changeData({ label: 'original_equity', data: JSON.stringify(data) })} />
          {!!Object.keys(old_data).length && <div style={{ marginTop: 24, fontWeight: 500, fontSize: 18, color: '#064b6f', textAlign: 'start' }}>本次擬變更之股權架構</div>}
          {!!Object.keys(old_data).length && <Tree disabled={disabled} data={data.change_equity || '[]'} onChange={data => this.changeData({ label: 'change_equity', data: JSON.stringify(data) })} />}
        </SearchBar>

        <Extend_Additional disabled={disabled} data={data.sub1 || []} onChange={data => this.changeData({ label: 'sub1', data })} />

        <SearchBar style={{ marginTop: 8 }} text='審查結果' forceOpen={errorAry[7] || errorAry[8] || errorAry[9]}>
          <div style={{ fontWeight: 700, fontSize: 16, textAlign: 'start', color: checkChange('review_results') ? 'red' : 'black' }}>本次股權申請案已取得經濟部</div>
          <EAA_Row style={{ marginTop: 8 }}>
            <EAA_Item>
              <EAA_ItemContainer>
                <CircleCheckBox value={data.review_results === '1'} onClick={() => this.changeData({ label: 'review_results', data: '1' })} />
                <div style={{ marginRight: 8 }}>同意變更</div>
                <CircleCheckBox value={data.review_results === '2'} onClick={() => this.changeData({ label: 'review_results', data: '2' })} />
                <div>不同意變更</div>
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>
          <div style={{ marginTop: 24, fontWeight: 700, fontSize: 16, textAlign: 'start' }}>經濟部同意/不同意函文</div>
          <EAA_Row style={{ marginTop: 8 }}>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='公文日期' bol={true} haveChange={checkChange('review_official_doc_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.review_official_doc_date)} onChange={data => this.changeData({ label: 'review_official_doc_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[7] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='公文文號' bol={true} haveChange={checkChange('review_official_doc_num')} />
                <EAA_Input displayBorder disabled={disabled} unit='字號' value={returnInputValue(data.review_official_doc_num)} onChange={data => this.changeData({ label: 'review_official_doc_num', data })} />
              </EAA_ItemContainer>
              {errorAry[8] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
          </EAA_Row>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='上傳檔案' bol={true} haveChange={checkFilesChange('review_official_doc_upload_files')} />
                <EAA_Upload displayBorder disabled={disabled} value={data.review_official_doc_upload_files || []} onChange={data => this.changeData({ label: 'review_official_doc_upload_files', data })} />
              </EAA_ItemContainer>
              {/* {errorAry[9] && <EAA_ErrorText marginLeft={errorLeft} text='帳號需為 1 ~ 100 英數字。' />} */}
            </EAA_Item>
          </EAA_Row>
        </SearchBar>

        <div style={{ height: 16 }} />

        <EAA_Status data={data} />
        <EAA_UpdateTime data={data} />

        <EAA_BottomBtn
          {...{
            data,
            mode,
            isCheck,
            allRight,
            canSend,
            onClose: this._onClose,
            goToCheck: this.goToCheck,
            goToEdit: this.goToEdit,
            add: this.add,
            edit: this.edit,
          }}
        />

        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewAEquity' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutAEquityIdDetail' />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  AEquityIdDetail: state.data.AEquityIdDetail,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getAEquityIdDetail: id => Actions_Wind.getAEquityIdDetail(dispatch, { id }),
  postAddNewAEquity: body => Actions_Wind.postAddNewAEquity(dispatch, { body }),
  putAEquityIdDetail: (id, body) => Actions_Wind.putAEquityIdDetail(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
